import * as React from "react";
import { cn } from "../lib/utils";
import { Button } from "./button";

const EmptyState = React.forwardRef(
  ({ className, icon: Icon, title, description, action, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-col items-center justify-center py-12 px-4 text-center",
          className,
        )}
        {...props}
      >
        {Icon && (
          <div className="mb-4 rounded-full bg-muted p-3">
            <Icon className="h-6 w-6 text-muted-foreground" />
          </div>
        )}
        {title && (
          <h3 className="mb-2 text-lg font-display font-semibold tracking-tight text-foreground">
            {title}
          </h3>
        )}
        {description && (
          <p className="mb-6 max-w-sm text-sm text-muted-foreground">
            {description}
          </p>
        )}
        {action && <div className="flex items-center gap-2">{action}</div>}
      </div>
    );
  },
);
EmptyState.displayName = "EmptyState";

export { EmptyState };
